import React from 'react';
import PropTypes from 'prop-types';
import DateTime from '_class/DateTime';
import { useTranslate } from 'lib/translate';
import { capitalize } from 'helpers/content';
import DOMPurify from 'dompurify';
import { Collapsible } from 'UI';
import { Icon } from '@haldor/ui';
import './_displayFeedbacks.scss';
var DisplayFeedbacks = function DisplayFeedbacks(_ref) {
  var feedbacks = _ref.feedbacks,
    resource = _ref.resource,
    resources = _ref.resources;
  var translate = useTranslate();

  /**
   * @returns {array} feedbacks
   */
  var getPublicFeedbacks = function getPublicFeedbacks() {
    if (feedbacks == null) {
      return [];
    }
    return feedbacks.filter(function (feedback) {
      return !feedback.isPrivate;
    });
  };

  /**
   * @returns {array} feedbacks
   */
  var getPrivateFeedbacks = function getPrivateFeedbacks() {
    if (feedbacks == null) {
      return [];
    }
    return feedbacks.filter(function (feedback) {
      return feedback.isPrivate;
    });
  };
  var getResource = function getResource(feedback) {
    if (resource != null) {
      return resource;
    }
    if (resources.length > 0) {
      return resources.find(function (resource) {
        return feedback.assessmentBlockPartId == resource.id;
      });
    }
    return null;
  };
  var renderFeedback = function renderFeedback(feedback, index) {
    var _feedback$editorUser, _feedback$editorUser2;
    var resource = getResource(feedback);
    return /*#__PURE__*/React.createElement("div", {
      className: "feedback",
      key: feedback.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "df jcb aic size-12",
      style: {
        marginBottom: '.4rem'
      }
    }, /*#__PURE__*/React.createElement("div", null, feedback.navigationObject != null ? feedback.navigationObject.referenceType == 'PLAN' ? translate('Plan') + ' • ' + feedback.navigationObject.title : translate('Assignment') + ' • ' + feedback.navigationObject.title : null), /*#__PURE__*/React.createElement("div", null, "".concat(((_feedback$editorUser = feedback.editorUser) === null || _feedback$editorUser === void 0 ? void 0 : _feedback$editorUser.firstName) || '', " ").concat(((_feedback$editorUser2 = feedback.editorUser) === null || _feedback$editorUser2 === void 0 ? void 0 : _feedback$editorUser2.lastName) || '').trim(), ' • ' + new DateTime(feedback.edited != null && feedback.edited > '2000-01-01T00:00:00' ? feedback.edited : feedback.created).getLongDate())), /*#__PURE__*/React.createElement("div", {
      className: "df jcb ais"
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: feedback.text
      }
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "display-feedbacks"
  }, getPublicFeedbacks().length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "collapsible-container"
  }, /*#__PURE__*/React.createElement(Collapsible, {
    ignorePropsUpdate: true,
    open: true,
    trigger: translate('Feedback')
  }, getPublicFeedbacks().map(renderFeedback))) : null, getPrivateFeedbacks().length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "collapsible-container"
  }, /*#__PURE__*/React.createElement(Collapsible, {
    trigger: translate('Personal notes')
  }, getPrivateFeedbacks().map(renderFeedback))) : null);
};
DisplayFeedbacks.propTypes = {
  feedbacks: PropTypes.array,
  resource: PropTypes.object,
  resources: PropTypes.array
};
DisplayFeedbacks.defaultProps = {
  resource: null,
  resources: []
};
export default DisplayFeedbacks;